module.exports = global["_"] = require("-!./underscore.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?_!./~/underscore/underscore.js
// module id = 519
// module chunks = 6